import axios from "axios";
import {authHeader} from "_helpers";
import {SERVER_URL} from "../config";

function getFbPhotos(params) {
    const endpoint = `${SERVER_URL}/api/v2/facebook/media`;

    return axios.get(endpoint,{
        params,
        headers: authHeader()
    })
}

export const metaService = {
    getFbPhotos
}